import { useSyncExternalStore } from 'react';

/**
 * Card Studio visibility (v8, BOLT-012). Same tiny external-store pattern as the
 * How-to-Play store — Landing/Lobby open it without threading props. The studio
 * runs entirely on synthetic data + a baked-in real boundary (no GPS, no socket),
 * so App renders it as an overlay like How-to-Play.
 */
let open = false;
const subs = new Set<() => void>();
const emit = () => subs.forEach((s) => s());

export const studioStore = {
  snapshot: () => open,
  open() {
    if (!open) {
      open = true;
      emit();
    }
  },
  close() {
    if (open) {
      open = false;
      emit();
    }
  },
  subscribe(cb: () => void) {
    subs.add(cb);
    return () => subs.delete(cb);
  },
};

export function useStudioOpen(): boolean {
  return useSyncExternalStore(studioStore.subscribe, studioStore.snapshot, studioStore.snapshot);
}
